<tool-form formTitle="Profile Filters">
  <form
    [formGroup]="cohortForm"
    (ngSubmit)="cohortFormSubmit()"
    class="form-content"
  >
    <!-- Year Dropdown Checkbox  -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Year(s)</mat-label>
      <mat-select
        formControlName="years"
        multiple
        required
        (selectionChange)="handleYearsUpdate($event)"
      >
        <mat-select-trigger>
          {{
            cohortForm.get('years')?.value?.includes('All')
              ? 'All'
              : cohortForm.get('years')?.value
          }}
        </mat-select-trigger>
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let year of yearList" [value]="year"
          >{{ year }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="cohortForm.get('years')?.invalid"
        >Please select at least one year</mat-error
      >
    </mat-form-field>

    <!-- Admit Types Dropdown Checkbox  -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Admit Type(s)</mat-label>
      <mat-select
        formControlName="admit_types"
        multiple
        required
        (selectionChange)="handleAdmitTypesUpdate($event)"
      >
        <mat-select-trigger>
          {{
            cohortForm.get('admit_types')?.value?.includes('All')
              ? 'All'
              : cohortForm.get('admit_types')?.value
          }}
        </mat-select-trigger>
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let admitType of admitTypes" [value]="admitType"
          >{{ admitType }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="cohortForm.get('admit_types')?.invalid"
        >Please select at least one admit type</mat-error
      >
    </mat-form-field>

    <!-- Tier Dropdown -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Tier(s)</mat-label>
      <mat-select
        formControlName="tiers"
        multiple
        required
        (selectionChange)="handleTiersUpdate($event)"
      >
        <mat-select-trigger>
          {{
            cohortForm.get('tiers')?.value?.includes('All')
              ? 'All'
              : formatTiersDisplay(cohortForm.get('tiers')?.value!)
          }}
        </mat-select-trigger>
        <mat-option value="All" #allTiersOption>All</mat-option>
        <mat-option *ngFor="let tier of tierList" [value]="tier"
          >{{ tier || 'No Tier' }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="cohortForm.get('tiers')?.invalid"
        >Please select at least one tier</mat-error
      >
    </mat-form-field>

    <!-- Financial Aid Status Dropdown -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Financial Aid Status</mat-label>
      <mat-select name="financial_aid" formControlName="financial_aid" required>
        <mat-option value="all">All</mat-option>
        <mat-option value="yes">Yes</mat-option>
        <mat-option value="no">No</mat-option>
      </mat-select>
      <mat-error *ngIf="cohortForm.get('financial_aid')?.invalid"
        >Please select a value</mat-error
      >
    </mat-form-field>

    <!-- High School GPA Input -->
    <div class="form-slider-container">
      <mat-label class="form-slider-text-label">High School GPA</mat-label>
      <mat-slider class="form-slider" min="0" max="5" step="0.25">
        <input
          value="0"
          matSliderStartThumb
          #sliderStartHS
          formControlName="high_school_gpa_lower"
        />
        <input
          value="5"
          matSliderEndThumb
          #sliderEndHS
          formControlName="high_school_gpa_upper"
        />
      </mat-slider>
      <div class="form-slider-value-label-container">
        <label>{{ sliderStartHS.value }}</label>
        <label>{{ sliderEndHS.value }}</label>
      </div>
    </div>
    <div class="cohort-form-info-text">Replaced NAs with 0.00</div>

    <!-- UWF GPA Input -->
    <div class="form-slider-container">
      <mat-label class="form-slider-text-label">UWF GPA</mat-label>
      <mat-slider class="form-slider" min="0" max="4" step="0.25">
        <input
          value="0"
          matSliderStartThumb
          #sliderStartUWF
          formControlName="uwf_gpa_lower"
        />
        <input
          value="4"
          matSliderEndThumb
          #sliderEndUWF
          formControlName="uwf_gpa_upper"
        />
      </mat-slider>
      <div class="form-slider-value-label-container">
        <label>{{ sliderStartUWF.value }}</label>
        <label>{{ sliderEndUWF.value }}</label>
      </div>
    </div>
    <div class="cohort-form-info-text">Replaced NAs with 0.00</div>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="disabledSubmitButton()"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
